import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoginForm from '../components/auth/LoginForm';
import Splash from '../components/Splash';
import ParticleBackground from '../components/ParticleBackground';
import { useThemeContext } from '../contexts/ThemeContext';
import { useAppContext } from '../contexts/Storage';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { isDark } = useThemeContext();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { token, user } = useAppContext();

  useEffect(() => {
    // If already logged in, redirect to dashboard
    if (token && user) {
      navigate('/dashboard');
    }
  }, [navigate, token]);
  

  return (
    <div className={`min-h-screen flex flex-col lg:flex-row relative `}>
      {/* Particle Background */}
      <ParticleBackground />
      
      {/* Login Form Side - White Container */}
      <LoginForm />

    </div>
  );
};

export default LoginPage;